import { render, staticRenderFns } from "./RedeemVoucher.vue?vue&type=template&id=44491e38&scoped=true&"
import script from "./RedeemVoucher.vue?vue&type=script&lang=ts&"
export * from "./RedeemVoucher.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44491e38",
  null
  
)

export default component.exports